export default "__VITE_ASSET__CA5QFQq___"